import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Inject Bearer token fallback (some browsers strip third-party cookies)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('access_token');
  if (t && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return 'Tuntematon virhe.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

/** Fetch a PDF endpoint as a Blob (with Bearer/cookie auth) and trigger download. */
export async function downloadPdf(pathWithApiPrefix, fallbackFilename) {
  const token = localStorage.getItem('access_token');
  // Cache-busting: append a unique timestamp to every PDF fetch. Without this
  // some browsers (notably Chrome) may return a stale cached PDF for the same
  // URL even after the underlying order has changed — e.g. the Lähete shows
  // the previous quantity instead of the just-saved one. Append before any
  // existing query string so we don't break consumers using query parameters.
  const cacheBust = `_=${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const sep = pathWithApiPrefix.includes('?') ? '&' : '?';
  const fetchUrl = `${BACKEND_URL}${pathWithApiPrefix}${sep}${cacheBust}`;
  const resp = await fetch(fetchUrl, {
    headers: token ? { Authorization: `Bearer ${token}`, 'Cache-Control': 'no-cache' } : { 'Cache-Control': 'no-cache' },
    credentials: 'include',
    cache: 'no-store',
  });
  if (!resp.ok) {
    let msg = `HTTP ${resp.status}`;
    try {
      const data = await resp.json();
      msg = formatApiErrorDetail(data.detail) || msg;
    } catch {}
    throw new Error(msg);
  }
  // Force application/octet-stream so the browser always downloads instead of
  // trying to render/open the file (Chrome can silently fail with text/csv on
  // some Windows setups where Excel association is broken).
  const buffer = await resp.arrayBuffer();
  const blob = new Blob([buffer], { type: 'application/octet-stream' });
  const dispo = resp.headers.get('content-disposition') || '';
  const fname = dispo.match(/filename="([^"]+)"/)?.[1] || fallbackFilename;
  const a = document.createElement('a');
  const url = URL.createObjectURL(blob);
  a.href = url;
  a.download = fname;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  // Delay cleanup so the browser has time to start the download before the
  // anchor + blob URL are removed. Some Chromium versions fail silently if
  // the URL is revoked too quickly.
  setTimeout(() => {
    if (a.parentNode) a.parentNode.removeChild(a);
    URL.revokeObjectURL(url);
  }, 1000);
  return fname;
}
